import Sidebar from '../Components/Sidebar/Sidebar';
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import ListaDocumento from '../Components/ListaDocumento/listaDocumento';
import { PageHeader } from '../Components/ui';
import CadastroFormDrawer from '../Components/CadastroFormDrawer/CadastroFormDrawer';
import ChamadoAttachmentField from '../../Solicitante/NovaSati/components/ChamadoAttachmentField';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';
import './historicoDocumento.css';

function HistoricoDocumento() {
    const { id: areDoc } = useParams();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editDoc, setEditDoc] = useState(null);
    const [data, setData] = useState([]);
    const [desDoc, setDesDoc] = useState('');
    const [arquivoBase64, setArquivoBase64] = useState('');
    const [fileName, setFileName] = useState('');
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState('');
    const history = useHistory();

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    }, [history]);

    const fetchData = useCallback(async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        const base = ensureProtocol(localStorage.getItem('ipBackend2') || '');
        try {
            const response = await axios.get(base + '/documentos', {
                headers: { Authorization: token },
                params: { areDoc }
            });
            const arr = Array.isArray(response.data) ? response.data : [];
            setData(arr.map((item) => ({
                id: item.SEQDOC,
                sequencia: item.SEQDOC,
                descricao: item.DESDOC,
                nome: item.NOMDOC,
                arquivo: item.ARQUIVO,
                tipo: item.TIPDOC || 0,
                area: areDoc
            })));
        } catch (err) {
            console.error('Erro ao buscar documentos:', err);
            setData([]);
        }
    }, [areDoc]);

    useEffect(() => {
        verificar();
        fetchData();
    }, [verificar, fetchData]);

    const abrirDrawerNovo = () => {
        setEditDoc(null);
        setDesDoc('');
        setArquivoBase64('');
        setFileName('');
        setErro('');
        setDrawerOpen(true);
    };

    const abrirDrawerEditar = (doc) => {
        setEditDoc(doc);
        setDesDoc(doc.descricao || '');
        setArquivoBase64(doc.arquivo ? (typeof doc.arquivo === 'string' && doc.arquivo.startsWith('data:') ? doc.arquivo : `data:application/octet-stream;base64,${doc.arquivo}`) : '');
        setFileName(doc.nome || '');
        setErro('');
        setDrawerOpen(true);
    };

    const fecharDrawer = () => {
        setDrawerOpen(false);
        setEditDoc(null);
        setDesDoc('');
        setArquivoBase64('');
        setFileName('');
        setErro('');
    };

    const salvarDocumento = async (e) => {
        e.preventDefault();
        const descricaoTrim = (desDoc || '').trim();
        const descricaoVal = descricaoTrim.length > 0 ? descricaoTrim : 'SEM DESCRIÇÃO FORNECIDA.';
        if (!editDoc && (!arquivoBase64 || !fileName?.trim())) {
            setErro('Arraste um arquivo ou selecione um documento.');
            return;
        }
        setErro('');
        setSalvando(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        const base = ensureProtocol(localStorage.getItem('ipBackend2') || '');
        try {
            if (editDoc) {
                await axios.put(base + '/documentos', {
                    seqDoc: editDoc.sequencia,
                    desDoc: descricaoVal,
                    nomDoc: (fileName || '').trim() || editDoc.nome,
                    Arquivo64: arquivoBase64 || (editDoc.arquivo && (editDoc.arquivo.startsWith('data:') ? editDoc.arquivo : `data:application/octet-stream;base64,${editDoc.arquivo}`))
                }, { headers: { Authorization: token } });
            } else {
                await axios.post(base + '/documentos', {
                    areDoc,
                    tipDoc: 0,
                    desDoc: descricaoVal,
                    nomDoc: (fileName || '').trim(),
                    Arquivo64: arquivoBase64
                }, { headers: { Authorization: token } });
            }
            fetchData();
            fecharDrawer();
        } catch (err) {
            setErro(err?.response?.data?.error || 'Erro ao salvar documento.');
        } finally {
            setSalvando(false);
        }
    };

    const tituloArea = areDoc === '0' ? 'Gerais' : (areDoc === '1' ? 'de Infraestrutura' : 'de Sistemas');
    const tituloDrawer = editDoc ? 'Editar documento' : 'Inserir documento';

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo historico-documento-page">
                    <PageHeader
                        title={`Documentos ${tituloArea}`}
                        icon="fas fa-folder-open"
                        actions={(
                            <>
                                <button onClick={abrirDrawerNovo} className="ax-btn ax-btn--primary" type="button">
                                    <i className="fas fa-plus" aria-hidden="true" /> Inserir Documento
                                </button>
                                <button onClick={fetchData} className="ax-btn" type="button">
                                    <i className="fas fa-sync-alt" aria-hidden="true" /> Atualizar
                                </button>
                            </>
                        )}
                    />
                    <div className="lista-wrapper">
                        <ListaDocumento
                            arrayDocumento={data}
                            onEdit={abrirDrawerEditar}
                            onDeleteSuccess={fetchData}
                        />
                    </div>
                </div>

                <CadastroFormDrawer
                    open={drawerOpen}
                    onClose={fecharDrawer}
                    title={tituloDrawer}
                >
                    <form className="documento-drawer-form cadastro-form-drawer-form" onSubmit={salvarDocumento}>
                        <div className="form-group">
                            <label>Descrição</label>
                            <input
                                type="text"
                                value={desDoc}
                                onChange={(e) => setDesDoc(e.target.value)}
                                className="form-control form-control-sm"
                                placeholder="Descrição do documento"
                            />
                        </div>
                        <div className="form-group documento-drawer-attachment">
                            <ChamadoAttachmentField
                                id="documento-drawer-arquivo"
                                nomeArquivo={fileName}
                                onFileChange={({ base64, nome }) => {
                                    setArquivoBase64(base64 || '');
                                    setFileName(nome || '');
                                }}
                            />
                            {editDoc && fileName && (
                                <p className="small text-muted mt-1 mb-0">Deixe o arquivo como está ou arraste outro para substituir.</p>
                            )}
                        </div>
                        {erro && <div className="alert alert-danger py-2 mb-2">{erro}</div>}
                        <div className="cadastro-form-drawer-form__actions">
                            <button type="button" className="btn btn-secondary btn-sm" onClick={fecharDrawer}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-primary btn-sm" disabled={salvando}>
                                {salvando ? 'Salvando...' : 'Salvar'}
                            </button>
                        </div>
                    </form>
                </CadastroFormDrawer>
            </main>
        </div>
    );
}

export default HistoricoDocumento;
